import React from "react";

function TopArtistListView() {
  const artist = [
    {
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "Bubblegoose",
      followers: "55 Followers",
    },
    {
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "DeGods",
      followers: " 24 Followers",
    },
    {
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
      followers: " 32 Followers",
    },
    {
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
      followers: " 54 Followers",
    },
  ];

  return (
    <div className="artistList">
      {Array(4)
        .fill(artist)
        .flat()
        .sort(() => 0.5 - Math.random())
        .map((e, index) => {
          return (
            <div className="artistRow">
              <div className="artistRowpic">
                <img src={e.profileImg} alt="profile_Pic" />
              </div>
              <div className="d-flex align-items-center">
                <h4>{e.profileName}</h4>
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </div>
              <div>
                <p>{e.followers}</p>
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default TopArtistListView;
